import { Menu, MenuItem, Highlighter, Typeahead, Token } from 'react-bootstrap-typeahead';
export { Highlighter as AutocompleteHighlighter, Menu as AutocompleteMenu, MenuItem as AutocompleteMenuItem, Token as AutocompleteToken } from 'react-bootstrap-typeahead';
import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { useMedia } from 'react-use-media';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded$1 = ["innerRef", "renderMenu", "options"];
function useAutocomplete(props) {
  var innerRef = props.innerRef,
      renderMenu = props.renderMenu,
      options = props.options,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var sortResults = function sortResults(results, args) {
    var labelKey = args.labelKey,
        text = args.text;

    var toVal = function toVal(item) {
      return typeof item === 'string' ? item : item[labelKey].toString();
    };

    return text ? results.sort(function (a, b) {
      var aVal = toVal(a).toLowerCase();
      var bVal = toVal(b).toLowerCase();
      var matchA = aVal.indexOf(text.toLowerCase()) !== -1 ? aVal : -1;
      var matchB = bVal.indexOf(text.toLowerCase()) !== -1 ? bVal : -1;
      return matchA < matchB ? -1 : 1;
    }) : results;
  };

  var isWide = useMedia({
    minWidth: 480
  });

  var renderResults = function renderResults(results, menuProps, propsFromEl) {
    return /*#__PURE__*/React.createElement(Menu, menuProps, sortResults(results, propsFromEl).map(function (result, index) {
      var keyId = index;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: keyId,
        option: result,
        position: index
      }, /*#__PURE__*/React.createElement(Highlighter, {
        search: propsFromEl.text
      }, result[propsFromEl.labelKey] || result));
    }));
  };

  return _objectSpread2({
    renderResults: renderResults,
    innerRef: innerRef,
    renderMenu: renderMenu,
    options: options,
    isWide: isWide
  }, attributes);
}

var _excluded = ["renderResults", "innerRef", "renderMenu", "options", "isWide"];

function Autocomplete(props) {
  var _useAutocomplete = useAutocomplete(props),
      renderResults = _useAutocomplete.renderResults,
      innerRef = _useAutocomplete.innerRef,
      renderMenu = _useAutocomplete.renderMenu,
      options = _useAutocomplete.options,
      isWide = _useAutocomplete.isWide,
      attributes = _objectWithoutProperties(_useAutocomplete, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: " autocomplete-input-container pr-5 flex-grow-1  "
  }, /*#__PURE__*/React.createElement(Typeahead, _extends({
    maxResults: isWide ? 8 : 5,
    options: options,
    ref: innerRef
  }, attributes, {
    renderMenu: renderMenu || renderResults
  }))), /*#__PURE__*/React.createElement("span", {
    className: "autocomplete-search-icon icon prism-icon-search"
  }));
}

Autocomplete.propTypes = {
  bsSize: PropTypes.string,
  caseSensitive: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  defaultSelected: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  ignoreDiacritics: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  isInvalid: PropTypes.bool,
  isValid: PropTypes.bool,
  labelKey: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  minLength: PropTypes.number,
  multiple: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onInputChange: PropTypes.func,
  onMenuHide: PropTypes.func,
  onMenuShow: PropTypes.func,
  onMenuToggle: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string, PropTypes.array]),
  paginate: PropTypes.bool,
  placeholder: PropTypes.string,
  clearButton: PropTypes.bool,
  id: PropTypes.string,
  shouldSelect: PropTypes.bool,
  renderMenu: PropTypes.string
};
Autocomplete.defaultProps = {
  clearButton: true,
  bsSize: '',
  disabled: false,
  id: v4(),
  minLength: 3,
  paginate: false,
  shouldSelect: true,
  caseSensitive: false,
  children: null,
  className: '',
  defaultOpen: false,
  defaultSelected: [],
  ignoreDiacritics: false,
  innerRef: null,
  isInvalid: false,
  isValid: false,
  labelKey: 'label',
  multiple: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onInputChange: function onInputChange() {},
  onMenuHide: function onMenuHide() {},
  onMenuShow: function onMenuShow() {},
  onMenuToggle: function onMenuToggle() {},
  options: [],
  placeholder: '',
  renderMenu: ''
};

Autocomplete.Highlighter = Highlighter;
Autocomplete.Menu = Menu;
Autocomplete.MenuItem = MenuItem;
Autocomplete.Token = Token;

export { Autocomplete as default };
//# sourceMappingURL=index.js.map
